type Options = {
  vertical?: boolean;
  snap?: Ref<number>;
};

export function useMobileTouchScroll(
  element: Ref<HTMLElement | undefined>,
  translate: Ref<number>,
  options: Options = {},
) {
  const { vertical, snap } = Object.assign<Options, Options>(
    {
      vertical: false,
    },
    options,
  );

  const initialTranslate = ref<number>(0);
  const max = ref<number>(0);

  const position = {
    x: 0,
    y: 0,
  };

  onMounted(() => {
    if (!element.value) return;

    const rect = element.value.getBoundingClientRect();

    const screen = window.screen.width;

    if (vertical) {
      max.value = rect.height - screen / 2;
    } else {
      max.value = rect.width - screen / 2;
    }

    element.value.addEventListener('touchstart', onTouchStart);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('touchstart', onTouchStart);
  });

  const onTouchStart = (event: TouchEvent) => {
    initialTranslate.value = translate.value;

    const touch = event.touches[0];
    position.x = touch.clientX;
    position.y = touch.clientY;

    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchend', onTouchEnd);
  };

  const onTouchMove = (event: TouchEvent) => {
    const touch = event.touches[0];
    const dx = touch.clientX - position.x;
    const dy = touch.clientY - position.y;

    requestAnimationFrame(() => {
      const offset = vertical ? dy : dx;

      let newTranslate = initialTranslate.value + offset;

      if (isRef(snap)) {
        newTranslate = Math.round(newTranslate * snap.value) / snap.value;
      }

      if (Math.abs(newTranslate) > max.value) {
        newTranslate = max.value * -1;
      } else if (newTranslate > 0) {
        newTranslate = 0;
      }

      translate.value = newTranslate;
    });
  };

  const onTouchEnd = () => {
    position.x = 0;
    position.y = 0;

    document.removeEventListener('touchmove', onTouchMove);
    document.removeEventListener('touchend', onTouchEnd);
  };
}
